import React from 'react'
import { Message } from '@afterpaytouch/core'
import { useTranslation } from '../../utils/convergence'
import styles from './styles.module.css'

export const AutopayMessage: React.FC = () => {
  const { t } = useTranslation()

  return (
    <div className={styles.autopayMessageBoxContainer}>
      <Message kind='Basic' description={t('summary:autopay.messageBox')} />
    </div>
  )
}
